
















import RefuelingForm from "@/components/RefuelingForm.vue";
import { Component, Vue } from "vue-property-decorator";
import { RefuelingHistoryEntry } from "@/types/refuelingEvent";
import HistoryChart from "@/components/HistoryChart.vue";
import RefuelingEntry from "@/components/RefuelingEntry.vue";
import Total from "@/components/Total.vue";
import * as firebase from "firebase/app";
import "firebase/database";
@Component({
  components: {
    Total,
    HistoryChart,
    RefuelingEntry,
    RefuelingForm
  }
})
export default class Home extends Vue {
  name = "Home";

  mounted() {
    const refuelingRef = firebase.database().ref("refueling-events");
    refuelingRef.on("value", snapshot => {
      const values = snapshot.val();
      const refuelingEvents = Object.keys(values).map(key => {
        const value = values[key];
        return {
          id: key,
          date: value.date,
          mileage: value.mileage,
          pricePerLiter: value.pricePerLiter,
          liters: value.liters,
          user: value.user
        }
      });
      this.$store.dispatch("setRefuelingEvents", refuelingEvents);
    });
  }

  get mostRecent(): RefuelingHistoryEntry {
    return this.$store.state.refuelings[0];
  }

  get secondMostRecent(): RefuelingHistoryEntry {
    return this.$store.state.refuelings[1];
  }
}
